import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { env } from '@/config/env';
import { loggedOut } from '@/slices/auth/constants/sessionSlice';

const rawBaseQuery = fetchBaseQuery({
  baseUrl: env.apiBaseUrl,
  credentials: 'include',
});

// Wraps the raw query: a 401 means the session cookie is gone, so log out client-side.
export const baseQueryWithReauth = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);

  if (result.error?.status === 401) {
    api.dispatch(loggedOut());
  }

  return result;
};
